import { toNestErrors, validateFieldsNatively, } from '@hookform/resolvers';
import { translation, } from '@tymia/main-api';
import { appendErrors, } from 'react-hook-form';
const parseErrorSchema = (ajvErrors, validateAllFieldCriteria) => {
    const parsedErrors = {};
    const reduceError = (error) => {
        // Ajv will return empty instancePath when require error
        if (error.keyword === 'required') {
            error.instancePath += `/${error.params.missingProperty}`;
        }
        // `/deepObject/data` -> `deepObject.data`
        const path = error.instancePath.substring(1).replace(/\//g, '.');
        if (!parsedErrors[path]) {
            parsedErrors[path] = {
                message: error.message,
                type: error.keyword,
            };
        }
        if (validateAllFieldCriteria) {
            const types = parsedErrors[path].types;
            const messages = types && types[error.keyword];
            parsedErrors[path] = appendErrors(path, validateAllFieldCriteria, parsedErrors, error.keyword, messages
                ? [].concat(messages, error.message || '')
                : error.message);
        }
    };
    for (let index = 0; index < ajvErrors.length; index += 1) {
        const error = ajvErrors[index];
        if (!error) {
            continue;
        }
        if (error.keyword === 'errorMessage') {
            error.params.errors.forEach(originalError => {
                originalError.message = error.message;
                reduceError(originalError);
            });
        }
        else {
            reduceError(error);
        }
    }
    return parsedErrors;
};
export function ajvResolver(validate, props) {
    return async (values, _, options) => {
        const [valid, result] = validate(values);
        // not sure why this is needed
        if (options.shouldUseNativeValidation) {
            validateFieldsNatively({}, options);
        }
        if (valid) {
            return {
                values,
                errors: {},
            };
        }
        const relevantFields = options.names;
        // map and filter
        const errors = result.flatMap(error => {
            if (relevantFields && !relevantFields.some(field => error.instancePath.endsWith(`/${field}`))) {
                return [];
            }
            // not relevant
            if (error.params.additionalProperty) {
                return [];
            }
            // enum is more detailed than type, so if both are present, we ignore the type error
            if (error.keyword === 'type' && result.some(r => r.instancePath === error.instancePath && r.keyword === 'enum')) {
                return [];
            }
            const definedError = error;
            if (definedError.message) {
                definedError.message = translation(props.locale).common.validation(definedError, props?.context);
            }
            return [definedError];
        });
        if (errors.length === 0) {
            return {
                values,
                errors: {},
            };
        }
        return {
            values: {},
            errors: toNestErrors(parseErrorSchema(errors, !options.shouldUseNativeValidation
                && options.criteriaMode === 'all'), options),
        };
    };
}
//# sourceMappingURL=ajvResolver.js.map